import { ReleaseNoteCategory } from "../api/generated";

export const CATEGORY_ICONS: Record<ReleaseNoteCategory, string> = {
  [ReleaseNoteCategory.FEATURE]: "✨",
  [ReleaseNoteCategory.IMPROVEMENT]: "⚡",
  [ReleaseNoteCategory.BUGFIX]: "🐛",
  [ReleaseNoteCategory.BREAKING_CHANGE]: "⚠️",
};

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + "…";
}

export function formatImportance(importance: number): string {
  const clamped = Math.max(1, Math.min(5, importance));
  const stars = "★".repeat(clamped);
  const emptyStars = "☆".repeat(5 - clamped);
  return stars + emptyStars;
}
